import { render } from "./App.vue?vue&type=template&id=d575664a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d575664a&lang=css"

import exportComponent from "/Users/kk/ulu/dev/UstoreWebPayPC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__